<!-- eslint-disable camelcase -->
<!-- eslint-disable camelcase -->
/* eslint-disable camelcase */
<template>
  <div class="position-relative">
    <button v-if="isAiInsightEnabled" @click="triggerInsight" class="ai-insight-btn" title="Get AI Map Analysis">
      <i class="el-icon-magic-stick"></i>
      AI Insight
      <span class="ai-sparkle" style="left: 10%; animation-delay: 0s"></span>
      <span class="ai-sparkle" style="left: 30%; animation-delay: 0.5s"></span>
      <span class="ai-sparkle" style="left: 60%; animation-delay: 1.2s"></span>
      <span class="ai-sparkle" style="left: 85%; animation-delay: 0.8s"></span>
    </button>
    <Highmaps :options="defaultOptions" ref="mapChart" />
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import loadMap from 'highcharts/modules/map';
import exportData from 'highcharts/modules/export-data';
import exporting from 'highcharts/modules/exporting';
import noData from 'highcharts/modules/no-data-to-display';
import loadDrilldown from 'highcharts/modules/drilldown';
import offlineExporting from 'highcharts/modules/offline-exporting';
import { genComponent } from 'vue-highcharts';

// default map
import NigerianMap from './ng-all.geo.json';

// default map options
import defaultOptions from './defaultOptions';

// map data
import regionsMap from './mapData/regions';

import {
  // eslint-disable-next-line camelcase
  AkwaIbom as Akwa_Ibom,
  Bayelsa,
  // eslint-disable-next-line camelcase
  CrossRiver as Cross_River,
  Rivers,
  Delta,
  Edo,
} from './mapData/south-south';

import {
  Abia, Ebonyi, Imo, Enugu, Anambra,
} from './mapData/south-east';

import {
  Ondo, Ogun, Osun, Lagos, Ekiti, Oyo,
} from './mapData/south-west';

import {
  Adamawa, Bauchi, Borno, Gombe, Taraba, Yobe,
} from './mapData/north-east';

import {
  Jigawa, Kano, Katsina, Kebbi, Sokoto, Kaduna, Zamfara,
} from './mapData/north-west';

import {
  Nasarawa, Niger, Plateau, Kwara, Kogi, Benue, Fct as FCT,
} from './mapData/north-central';

// load map
loadMap(Highcharts);
exporting(Highcharts);
offlineExporting(Highcharts);
exportData(Highcharts);
noData(Highcharts);
loadDrilldown(Highcharts);

export default {
  name: 'BaseMap',
  components: {
    Highmaps: genComponent('Highmaps', Highcharts),
  },
  props: {
    mapObject: {
      type: Object,
      default: () => ({}),
    },
    level: {
      type: Number,
      default: 0,
    },
    lgaState: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
    categoryLabel: {
      type: String,
      default: 'Category',
    },
  },
  data() {
    return {
      defaultOptions: { ...defaultOptions },
      lgaMapData: {
        Jigawa,
        Kano,
        Katsina,
        Kebbi,
        Sokoto,
        Kaduna,
        Zamfara,
        Nasarawa,
        Niger,
        Plateau,
        Kwara,
        Kogi,
        Benue,
        FCT,
        Abia,
        Ebonyi,
        Imo,
        Enugu,
        Anambra,
        Ondo,
        Ogun,
        Osun,
        Lagos,
        Ekiti,
        Oyo,
        Akwa_Ibom,
        Bayelsa,
        Cross_River,
        Rivers,
        Delta,
        Edo,
        Adamawa,
        Bauchi,
        Borno,
        Gombe,
        Taraba,
        Yobe,
      },
      tableRefreshTimer: null,
      tableRefreshing: false,
    };
  },
  computed: {
    isAiInsightEnabled() {
      // access plugin status from localStorage
      return localStorage.getItem('insightSummaryPlugin') === 'true';
    },
  },
  methods: {
    triggerInsight() {
      const chart = this.getChart();
      if (!chart) return;

      const payload = {
        title: this.title || 'Health Map Analysis',
        series: (chart.series || []).map((s) => {
          const extractedData = (s.options.data || []).map((d) => {
            if (typeof d === 'number') return d;
            if (Array.isArray(d)) return d[1];
            if (d && typeof d === 'object') {
              if (d.value !== undefined) return d.value;
              if (d.y !== undefined) return d.y;
              return 0;
            }
            return 0;
          });
          return {
            name: s.name,
            data: extractedData,
          };
        }),
        categories: (chart.series[0] && chart.series[0].data) ? chart.series[0].data.map((d) => d.name || d.id) : [],
      };

      this.$eventBus.$emit('show-insight', payload);
    },
    // Remove a leading "Distribution of" (case-insensitive) from titles
    sanitizedExportTitle(title) {
      if (!title || typeof title !== 'string') return title;
      return title.replace(/^\s*distribution\s+of\s+/i, '').trim();
    },
    getChart() {
      return this.$refs.mapChart && this.$refs.mapChart.chart;
    },

    getDataTableElement(chart) {
      if (!chart) return null;
      const byId = document.getElementById(`highcharts-data-table-${chart.index}`);
      if (byId) return byId;
      const parent = chart && chart.renderTo && chart.renderTo.parentNode;
      if (!parent) return null;
      return parent.querySelector('.highcharts-data-table');
    },

    removeExistingDataTable(chart) {
      if (!chart) return;
      const parent = chart && chart.renderTo && chart.renderTo.parentNode;
      if (!parent) return;
      const byId = document.getElementById(`highcharts-data-table-${chart.index}`);
      if (byId) {
        const container = (byId.classList && byId.classList.contains('highcharts-data-table'))
          ? byId
          : byId.parentNode;
        const closeBtn = container && container.querySelector && container.querySelector('.hc-data-close');
        if (closeBtn) closeBtn.remove();
        if (byId.classList && byId.classList.contains('highcharts-data-table')) {
          byId.remove();
        } else if (
          byId.tagName === 'TABLE'
          && byId.parentNode
          && byId.parentNode.classList
          && byId.parentNode.classList.contains('highcharts-data-table')
        ) {
          byId.parentNode.remove();
        } else {
          byId.remove();
        }
      }
      const tables = parent.querySelectorAll('.highcharts-data-table');
      tables.forEach((tbl) => tbl.remove());
    },

    refreshDataTableIfVisible() {
      const chart = this.getChart();
      if (!chart) return;
      const tableEl = this.getDataTableElement(chart);
      if (tableEl) {
        if (this.tableRefreshing) return;
        this.tableRefreshing = true;
        setTimeout(() => {
          try {
            this.removeExistingDataTable(chart);
            chart.isDataTableVisible = false;
            if (typeof chart.viewData === 'function') chart.viewData();
          } catch (e) {
            // ignore
          } finally {
            this.tableRefreshing = false;
          }
        }, 50);
      }
    },

    refreshDataTableIfVisibleDebounced() {
      clearTimeout(this.tableRefreshTimer);
      this.tableRefreshTimer = setTimeout(() => {
        this.refreshDataTableIfVisible();
      }, 120);
    },

    patchHighchartsViewDataOnce() {
      if (Highcharts.Chart.prototype.viewDataWithClosePatched) return;
      const originalView = Highcharts.Chart.prototype.viewData;
      const originalHide = Highcharts.Chart.prototype.hideData;
      if (typeof originalView !== 'function') return;

      Highcharts.Chart.prototype.viewData = function patchedViewData(...args) {
        const ret = originalView.apply(this, args);
        try {
          this.isDataTableVisible = true;
          const table = document.getElementById(`highcharts-data-table-${this.index}`)
            || (this.renderTo && this.renderTo.parentNode && this.renderTo.parentNode.querySelector('.highcharts-data-table'));
          if (table && !table.parentNode.querySelector('.hc-data-close')) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'hc-data-close';
            btn.textContent = 'Close';
            btn.style.position = 'absolute';
            btn.style.right = '8px';
            btn.style.top = '8px';
            btn.style.padding = '4px 8px';
            btn.style.fontSize = '12px';
            btn.style.border = 'none';
            btn.style.borderRadius = '3px';
            btn.style.background = '#e53935';
            btn.style.color = '#fff';
            btn.style.cursor = 'pointer';
            btn.style.zIndex = '10';
            const wrapper = table.parentNode;
            if (wrapper && getComputedStyle(wrapper).position === 'static') {
              wrapper.style.position = 'relative';
            }
            btn.addEventListener('click', () => {
              if (typeof this.hideData === 'function') this.hideData();
              this.isDataTableVisible = false;
            });
            wrapper.insertBefore(btn, table);

            // Customize the first column header
            const firstTh = table.querySelector('thead th:first-child');
            if (firstTh) {
              firstTh.textContent = this.options.categoryLabel || 'Category';
            }
          }
        } catch (e) {
          // ignore
        }
        return ret;
      };

      if (typeof originalHide === 'function') {
        Highcharts.Chart.prototype.hideData = function patchedHideData(...args) {
          const r = originalHide.apply(this, args);
          this.isDataTableVisible = false;
          return r;
        };
      }
      Highcharts.Chart.prototype.viewDataWithClosePatched = true;
    },

    plotMapLevel(level) {
      // check space is in string and add underscore
      let lgaState = '';
      if (this.lgaState) {
        lgaState = this.lgaState.replace(/\s/g, '_');
      }

      switch (level) {
        case 1:
          this.defaultOptions.plotOptions.map.mapData = NigerianMap;
          break;
        case 2:
          this.defaultOptions.plotOptions.map.mapData = regionsMap;
          break;
        case 3:
          this.defaultOptions.plotOptions.map.mapData = this.lgaMapData[lgaState].data;
          break;
        case 4:
          this.defaultOptions.plotOptions.map.mapData = NigerianMap;
          break;
        default:
          this.defaultOptions.plotOptions.map.mapData = NigerianMap;
          break;
      }
      this.defaultOptions = { ...this.defaultOptions };
      this.$nextTick(() => this.refreshDataTableIfVisibleDebounced());
    },
  },
  watch: {
    mapObject: {
      handler(newVal) {
        this.defaultOptions = Object.assign(this.defaultOptions, newVal);
        this.$nextTick(() => this.refreshDataTableIfVisibleDebounced());
      },
      immediate: true,
      deep: true,
    },
    level(newVal) {
      this.plotMapLevel(newVal);
    },
    lgaState() {
      this.plotMapLevel(this.level);
    },
    categoryLabel(newVal) {
      this.defaultOptions.categoryLabel = newVal;
    },
  },
  created() {
    this.plotMapLevel(this.level);
  },

  mounted() {
    // Patch Highcharts viewData once to add red Close button & state sync
    this.patchHighchartsViewDataOnce();
    // changing the title of the text when downloaded
    if (this.defaultOptions.exporting && this.defaultOptions.exporting.chartOptions) {
      this.defaultOptions.exporting.chartOptions.title.text = this.title;
    }
    // Set custom category label
    this.defaultOptions.categoryLabel = this.categoryLabel;

    // Listen for plugin changes
    this.$root.$on('plugins:changed', (payload) => {
      if (payload.plugin === 'insightSummaryPlugin') {
        localStorage.setItem('insightSummaryPlugin', payload.value ? 'true' : 'false');
        this.$forceUpdate();
      }
    });
  },
  beforeDestroy() {
    clearTimeout(this.tableRefreshTimer);
  },
};
</script>

<style lang="scss" scoped>
.ai-insight-btn {
  position: absolute;
  top: 15px;
  right: 65px;
  z-index: 1000;
  padding: 8px 18px;
  background: linear-gradient(135deg, #007d53 0%, #00a870 100%);
  color: white;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 125, 83, 0.4);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  overflow: hidden;
  animation: btn-pulse 2s infinite;
}

@keyframes btn-pulse {
  0% { transform: scale(1); box-shadow: 0 4px 15px rgba(0, 125, 83, 0.4); }
  50% { transform: scale(1.05); box-shadow: 0 4px 25px rgba(0, 125, 83, 0.6); }
  100% { transform: scale(1); box-shadow: 0 4px 15px rgba(0, 125, 83, 0.4); }
}

.ai-insight-btn::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(45deg);
  transition: all 0.5s;
}

.ai-insight-btn:hover {
  transform: translateY(-3px) scale(1.1);
  box-shadow: 0 8px 25px rgba(0, 125, 83, 0.6);
}

.ai-insight-btn i {
  font-size: 16px;
}

.ai-sparkle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: white;
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
  animation: sparkle-float 2s infinite ease-in-out;
}

@keyframes sparkle-float {
  0% { transform: translateY(0) scale(0); opacity: 0; }
  50% { opacity: 1; }
  100% { transform: translateY(-30px) scale(1.5); opacity: 0; }
}
</style>
